import { MAP__field_data } from '@shared/types/types';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { DECORATOR__field_not_linked } from '../_primitives/_base/DECORATOR__field_not_linked';
import { ENUM__field_connectable_type } from './_methods/ENUM__field_connectable_type';
import { FIELD__base } from './FIELD__base';

export class FIELD_GRID2D_MODE__base extends FIELD__base {
  /*
   *
   */
  static get_meta_params_default() {
    let out = super.get_meta_params_default();

    out.grid2d__can_be_dimension = true;
    out.data__is_required = false;

    return out;
  }

  /*
   *
   */
  field_connectable__type(): ENUM__field_connectable_type {
    return ENUM__field_connectable_type.GRID2D_MODE;
  }

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    return this.toString();
  }

  /*
   *
   */

  @DECORATOR__field_not_linked()
  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    return false;
  }

  /*
   *
   */

  store__can_deserialize_from_data(map: MAP__field_data) {
    return false;
  }
}
